/* eslint-disable react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import HomeIcon from "@mui/icons-material/Home";
import MoneyIcon from "@mui/icons-material/Money";
import RefreshIcon from "@mui/icons-material/Refresh";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import MultipleTransactionsCrud from "./MultipleTransactionsCrud";
import TransactionsCrud from "./TransactionsCrud.jsx";
import ChequePrint from "../ChequePrint/ChequePrint";
import PrintIcon from "@mui/icons-material/Print";
import { StringUtils } from "../../../utils/StringUtils";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function TransactionsList(props) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cashPaymentAnchorEl, setCashPaymentAnchorEl] = useState(null);
  const [bankPaymentAnchorEl, setBankPaymentAnchorEl] = useState(null);
  const [windowTitle, setWindowTitle] = useState("");
  const [userPrivilegeForUpdate, setUserPrivilegeForUpdate] = useState();
  const [userPrivilegeForDelete, setUserPrivilegeForDelete] = useState();
  const [viewOnlyForUpdate, setViewOnlyForUpdate] = useState("");
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 155) / 32)
  );

  const [searchStr, setSearchStr] = useState("");
  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    loadData();
    setWindowTitle(getWindowTitle(props.type));
    getUserPrivilege(props.type);
  }, []);

  function getUserPrivilege(type) {
    switch (type) {
      case "CONTRA":
        setUserPrivilegeForUpdate(
          props.context.privileges.inter_account_update
        );
        setUserPrivilegeForDelete(
          props.context.privileges.inter_account_delete
        );
        break;
      case "Payment":
        setUserPrivilegeForUpdate(
          props.context.privileges.account_payment_update
        );
        setUserPrivilegeForDelete(
          props.context.privileges.account_payment_delete
        );
        break;
      case "Receipt":
        setUserPrivilegeForUpdate(
          props.context.privileges.account_receipt_update
        );
        setUserPrivilegeForDelete(
          props.context.privileges.account_receipt_delete
        );
        break;
    }
  }

  function getWindowTitle(type) {
    if (type === "Receipt") {
      return translate("Receipt List");
    } else if (type === "Payment") {
      return translate("Payment List");
    } else if (type === "CONTRA") {
      return translate("Inter Account Transaction List");
    }
  }

  function addCashTransactions() {
    let transactionMode = "Cash";
    biRef.child.showTransactionsCrudWindow(transactionMode, null);
  }

  function handleMultiTransactions(transactionMode) {
    biRef.multiItemTransactionCrud.showTransactionsCrudWindow(
      transactionMode,
      null
    );
  }

  function addBankTransactions() {
    let transactionMode = "Bank";
    biRef.child.showTransactionsCrudWindow(transactionMode, null);
  }
  function addTransactions() {
    biRef.child.showTransactionsCrudWindow(null, null);
  }

  function onEditClicked(row) {
    biRef.child.showTransactionsCrudWindow(
      row.tableData[row.rowIndex].transactionMode,
      row.tableData[row.rowIndex].id
    );
  }

  function onViewClickedAtUpdate(row) {
    biRef.child.showTransactionsCrudWindow(
      row.tableData[row.rowIndex].transactionMode,
      row.tableData[row.rowIndex].id
    );
  }

  function onPrintClicked(row) {
    let paramsList = [
      {
        key: "transactionId",
        value: row.tableData[row.rowIndex].id,
      },
    ];

    if (props.type === "Payment") {
      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/account_transactions/payment",
        paramsList,
        translate("Accounts Transaction")
      );
    }

    if (props.type == "Receipt") {
      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/account_transactions/receipt",
        paramsList,
        translate("Accounts Transaction")
      );
    }
    if (props.type === "CONTRA") {
      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/account_transactions/contra",
        paramsList,
        translate("Accounts Transaction")
      );
    }
  }

  function onChequePrint(row) {
    biRef.chequeRef.showChequePrintWindow(
      row.tableData[row.rowIndex],
      "general"
    );
  }

  async function loadData() {
    loadByRest(0, rowLimitPerPage, "[]", "[]");
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    sort = '[{id:"transactionDate2",desc:true}]';
    setIsLoading(true);
    let type = "";
    switch (props.type) {
      case "CONTRA":
        type = "CONTRA";
        break;
      case "Payment":
        type = "Payment";
        break;
      case "Receipt":
        type = "Receipt";
        break;
    }
    const result = await API.get(
      "/api/v1/getacctransactions/" +
        type +
        "?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }

  async function loaadByDB() {
    db.transactions.toArray(function (data) {
      setData(data);
    });
  }

  async function onTableChange(tableState) {
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"fromLedgerName",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"toLedgerName",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"voucherNumber",value:"' + tableState.searchText + '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(tableState.page, tableState.rowsPerPage, sort, search);
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    download: false,
    viewColumns: false,
    filter: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    print: false,
    tableBodyHeight: getWindowDimensions().height - 162,
    rowsPerPage: Math.round((getWindowDimensions().height - 162) / 33),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 162) / 33),
      10,
      15,
      50,
      100,
    ],
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="secondary"
              onClick={transactionsListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          {(props.type === "Payment" || props.type === "Receipt") && (
            <Tooltip title={"Add Cash " + props.type}>
              <Button
                color="primary"
                onClick={(e) => {
                  setCashPaymentAnchorEl(e.currentTarget);
                }}
              >
                <MoneyIcon />
                {translate("Cash")}
                <sup>+</sup>
              </Button>
            </Tooltip>
          )}
          {(props.type === "Payment" || props.type === "Receipt") && (
            <Tooltip title={"Add Bank " + props.type}>
              <Button
                color="secondary"
                onClick={(e) => {
                  setBankPaymentAnchorEl(e.currentTarget);
                }}
              >
                <MoneyIcon />
                {translate("Bank")}
                <sup>+</sup>
              </Button>
            </Tooltip>
          )}
          {props.type === "CONTRA" && (
            <Tooltip title={"New inter account entry"}>
              <IconButton color="primary" onClick={addTransactions}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          )}
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "voucherNumber",
      label: translate("Voucher Number"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "transactionDate2",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    // {
    //   name: "transactionMode",
    //   label: translate("Mode"),
    //   options: {
    //     filter: false,
    //     sort: true,
    //     display: props.type === "CONTRA" ? "false" : "true",
    //   },
    // },
    {
      name: "fromLedgerName",
      label: translate("From"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "toLedgerName",
      label: translate("To"),
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "amount",
      label: translate("Amount"),
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "discount",
      label: translate("Discount"),
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "actualAmount",
      label: translate("Actual Amount"),
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            {tableMeta.tableData[tableMeta.rowIndex].transactionMode ===
              "Bank" && (
              <Button
                onClick={() => onChequePrint(tableMeta, updateValue, value)}
                color="secondary"
                style={{
                  marginRight: 35,
                  height: 17,
                  width: 30,
                  alignText: "right",
                }}
              >
                {translate("Cheque")}
                <PrintIcon
                  style={{
                    marginLeft: 5,
                  }}
                />
              </Button>
            )}
            {userPrivilegeForUpdate && (
              <Button
                onClick={() => {
                  onViewClickedAtUpdate(tableMeta, updateValue, value);
                  setViewOnlyForUpdate("only_view");
                }}
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("VIEW")}
              </Button>
            )}
            <Button
              onClick={() => {
                onEditClicked(tableMeta, updateValue, value);
                setViewOnlyForUpdate("");
              }}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {userPrivilegeForUpdate ? translate("UPDATE") : translate("VIEW")}
            </Button>
            <Button
              onClick={() => onPrintClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("Print")}
            </Button>
          </div>
        ),
      },
    },
  ];

  function transactionsListRefresh() {
    loadData();
  }

  var biRef = {};

  function handleCloseCashPaymentMenu() {
    setCashPaymentAnchorEl(null);
  }

  function handleCloseBankPaymentMenu() {
    setBankPaymentAnchorEl(null);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {windowTitle}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <TransactionsCrud
        biRef={biRef}
        type={props.type}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={transactionsListRefresh}
        showProgress={props.showProgress}
        hideProgress={props.hideProgress}
        userPrivilegeForUpdate={userPrivilegeForUpdate}
        userPrivilegeForDelete={userPrivilegeForDelete}
        viewOnlyForUpdate={viewOnlyForUpdate}
        setViewOnlyForUpdate={setViewOnlyForUpdate}
      ></TransactionsCrud>
      <MultipleTransactionsCrud
        biRef={biRef}
        type={props.type}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        onRefresh={transactionsListRefresh}
      ></MultipleTransactionsCrud>
      <ChequePrint
        biRef={biRef}
        showMessage={props.showMessage}
        showProgress={props.showProgress}
        hideProgress={props.hideProgress}
        setAlert={props.setAlert}
      ></ChequePrint>
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
      ></GenericReportViewer>
      <Menu
        anchorEl={cashPaymentAnchorEl}
        open={cashPaymentAnchorEl ? true : false}
        onClose={handleCloseCashPaymentMenu}
      >
        <MenuItem
          onClick={(e) => {
            addCashTransactions();
            handleCloseCashPaymentMenu();
          }}
        >
          {"Single " + props.type + " Cash Transaction"}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            handleMultiTransactions("Cash");
            handleCloseCashPaymentMenu();
          }}
        >
          {"Multiple " + props.type + " Cash Transaction"}
        </MenuItem>
      </Menu>
      <Menu
        anchorEl={bankPaymentAnchorEl}
        open={bankPaymentAnchorEl ? true : false}
        onClose={handleCloseBankPaymentMenu}
      >
        <MenuItem
          onClick={(e) => {
            addBankTransactions();
            handleCloseBankPaymentMenu();
          }}
        >
          {"Single " + props.type + " Bank Transaction"}
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            handleMultiTransactions("Bank");
            handleCloseBankPaymentMenu();
          }}
        >
          {"Multiple " + props.type + " Bank Transaction"}
        </MenuItem>
      </Menu>
    </Grid>
  );
}
